import React from 'react';
import { HomeIcon, AreaIcon, BuildingIcon, CityIcon, GardenIcon } from '../Icons/Icons';
import './BrowseByPropertyType.css';

function BrowseByPropertyType() {
  const propertyTypes = [
    {
      id: 1,
      name: 'Homes',
      filterValue: 'House',
      count: '28,543',
      icon: <HomeIcon size={40} color="#ffffff" />
    },
    {
      id: 2,
      name: 'Plots',
      filterValue: 'Plot',
      count: '34,219',
      icon: <AreaIcon size={40} color="#ffffff" />
    },
    {
      id: 3,
      name: 'Commercial',
      filterValue: 'Commercial',
      count: '15,876',
      icon: <BuildingIcon size={40} color="#ffffff" />
    },
    {
      id: 4,
      name: 'Apartments',
      filterValue: 'Flat',
      count: '41,632',
      icon: <CityIcon size={40} color="#ffffff" />
    },
    {
      id: 5,
      name: 'Farmhouses',
      filterValue: 'Farmhouse',
      count: '3,245',
      icon: <GardenIcon size={40} color="#ffffff" />
    },
    {
      id: 6,
      name: 'Villas',
      filterValue: 'Villa',
      count: '8,921',
      icon: <HomeIcon size={40} color="#ffffff" />
    }
  ];

  const handleTypeClick = (typeFilter) => {
    // Store property type filter in sessionStorage
    const searchParams = {
      propertyType: typeFilter
    };
    sessionStorage.setItem('searchParams', JSON.stringify(searchParams));

    // Navigate to listings page with property type filter
    if (window.navigateTo) {
      window.navigateTo('listings');
    } else {
      alert(`Navigating to ${typeFilter} properties`);
    }
  };

  return (
    <section className="browse-by-type">
      <div className="container">
        <div className="section-header">
          <h2>Browse by Property Type</h2>
          <p>Find the perfect property that suits your needs</p>
        </div>

        <div className="types-grid">
          {propertyTypes.map(type => (
            <div
              key={type.id}
              className="type-card"
              onClick={() => handleTypeClick(type.filterValue)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && handleTypeClick(type.filterValue)}
              aria-label={`Browse ${type.count} ${type.name} properties`}
            >
              <div className="type-icon">{type.icon}</div>
              <h3>{type.name}</h3>
              <p>{type.count} Properties</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BrowseByPropertyType;
